import { render, staticRenderFns } from "./DealList.vue?vue&type=template&id=452eb695&"
import script from "./DealList.vue?vue&type=script&lang=js&"
export * from "./DealList.vue?vue&type=script&lang=js&"
import style0 from "./DealList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports